var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("card-collapsable", {
    attrs: {
      headerClass: _vm.headerClass,
      dialogClass: "selvaggia",
      dialogProp: _vm.dialog,
    },
    scopedSlots: _vm._u([
      {
        key: "visible",
        fn: function () {
          return [
            _c("progress-countdown", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.asta_settings.timeout_s && _vm.calciatoreInAsta,
                  expression: "asta_settings.timeout_s && calciatoreInAsta",
                },
              ],
              ref: "timer_selvaggia",
              attrs: { time: _vm.asta_settings.timeout_s, name: "selvaggia" },
              on: { timeover: _vm.timeoverSelvaggia },
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "title",
        fn: function () {
          return [
            _vm._v(
              "\n    " +
                _vm._s(
                  _vm.ruoloCalciatoreInAstaCompletato
                    ? "Ruolo completato"
                    : _vm.creditiInsufficienti && !_vm.sonoVincitore
                    ? "Crediti insufficienti"
                    : _vm.hoPassato
                    ? "Hai passato"
                    : _vm.sonoVincitore
                    ? "Migliore offerta"
                    : "Fai offerta"
                ) +
                "\n  "
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _vm.calciatoreInAsta
              ? _c("calciatore-battuto", {
                  attrs: { id: _vm.calciatoreInAsta, xLarge: "" },
                })
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "text-center" }, [
              _c(
                "div",
                { staticClass: "d-flex justify-center" },
                [
                  _c("squadra-offerta", {
                    class: { sonoVincitore: _vm.sonoVincitore },
                    attrs: {
                      offerta: _vm.migliore_offerta.offerta,
                      uid: _vm.migliore_offerta.vincitore,
                      ifNoOfferta: "Nessuna offerta",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              !_vm.timeover &&
              _vm.running &&
              _vm.calciatoreInAsta !== null &&
              _vm.sonoVincitore &&
              _vm.creditiInsufficienti
                ? _c(
                    "div",
                    { staticClass: "pa-2" },
                    [
                      _c("v-chip", { staticClass: "white primary--text" }, [
                        _vm._v("Non puoi alzare ulteriormente l'offerta"),
                      ]),
                    ],
                    1
                  )
                : !_vm.timeover &&
                  _vm.running &&
                  _vm.calciatoreInAsta !== null &&
                  !_vm.hoPassato
                ? _c("div", { staticClass: "pa-4" }, [
                    _vm.migliore_offerta.offerta
                      ? _c(
                          "div",
                          { staticClass: "d-flex justify-center" },
                          [
                            !_vm.offertaToConfirm
                              ? _c(
                                  "v-btn",
                                  {
                                    staticClass: "ma-1",
                                    attrs: { rounded: "", color: "primary" },
                                    on: {
                                      click: function ($event) {
                                        _vm.offertaToConfirm =
                                          _vm.migliore_offerta.offerta + 1
                                      },
                                    },
                                  },
                                  [_vm._v("+1")]
                                )
                              : _vm.offertaToConfirm
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex flex-column align-center",
                                  },
                                  [
                                    _vm.offertaInsufficiente
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex align-center error--text",
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                staticClass: "error--text",
                                                attrs: { small: "", left: "" },
                                              },
                                              [_vm._v("error")]
                                            ),
                                            _vm._v(
                                              "\n              Offerta ora insufficiente. Vuoi offrire\n              " +
                                                _vm._s(_vm.offertaToConfirm) +
                                                " ?\n            "
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass: "ma-1",
                                        attrs: {
                                          rounded: "",
                                          color: "primary",
                                        },
                                        on: { click: _vm.confirmOfferta },
                                      },
                                      [
                                        _vm._v("Confermo\n              "),
                                        _c(
                                          "span",
                                          { staticClass: "ml-2 crediti" },
                                          [_vm._v(_vm._s(_vm.offertaToConfirm))]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "d-flex justify-center" },
                      [
                        _c(
                          "v-btn",
                          {
                            staticClass: "ma-1",
                            attrs: {
                              color: "primary",
                              id: "numpad-btn",
                              rounded: "",
                              depressed: "",
                            },
                            on: { click: _vm.showNumpad },
                          },
                          [_vm._v("\n            Offerta\n          ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            staticClass: "ma-1",
                            attrs: {
                              color: "primary",
                              outlined: "",
                              rounded: "",
                              disabled: _vm.vincitore === _vm.user_uid,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.setPasso(true)
                              },
                            },
                          },
                          [_vm._v("\n            Passo\n          ")]
                        ),
                      ],
                      1
                    ),
                  ])
                : _c(
                    "div",
                    { staticClass: "pa-2" },
                    [
                      _c("v-chip", { staticClass: "orange white--text" }, [
                        _vm._v("In attesa degli altri partecipanti..."),
                      ]),
                    ],
                    1
                  ),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "actions",
        fn: function () {
          return [
            _vm.my_squadra
              ? _c(
                  "div",
                  { staticClass: "pa-4" },
                  [
                    _c("squadra-info-panel", {
                      attrs: { id_squadra: _vm.user_uid },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.my_squadra
              ? _c(
                  "div",
                  { staticClass: "px-4 pb-4" },
                  [
                    _c(
                      "v-list",
                      {
                        staticClass:
                          "recycle-scroller navy darken-1 pb-2 rounded",
                        class: { "nice-scroll": !_vm.is_mobile },
                      },
                      [
                        _c("div", { staticClass: "text-center py-2 " }, [
                          _vm._v("Pianificazione"),
                        ]),
                        _vm._v(" "),
                        _c("asta-consiglio"),
                        _vm._v(" "),
                        _vm._l(
                          _vm.myPlan[_vm.ruolo_abc],
                          function (slotData, slot, i) {
                            return _c("asta-slot", {
                              key: _vm.ruolo_abc + "_" + slot,
                              attrs: {
                                ruolo_abc: _vm.ruolo_abc,
                                iSlot: slot,
                                i: i,
                              },
                            })
                          }
                        ),
                      ],
                      2
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }